import React, {useState, useEffect} from 'react'
import {setGTag} from '../google_tag_manager'

interface GoogleTagManagerProps {
    gtag: string | null
}

const GoogleTagManager: React.FC<GoogleTagManagerProps> = ({ gtag }) => {
    const [isTag, setIsTag] = useState<boolean>(false)

    useEffect(() => {
        if (gtag) {
            setGTag(gtag)
            setIsTag(true)
        }
    }, [gtag])


    return (
        <>
            {isTag &&
                <noscript>
                    <iframe
                        src={'https://www.googletagmanager.com/ns.html?id=' + gtag}
                        height='0' width='0' title={'googleTagManager'}>
                    </iframe>
                </noscript>
            }
        </>
    )
}

export default GoogleTagManager
